import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from 'primereact/tooltip';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { AutoComplete } from 'primereact/autocomplete';
import fileUpload from "../../../images/file-upload.svg";
import ReseFileuploadService , { getDriverConfigFileContent }from './ReseFileuploadService';
import { useSelector, useDispatch } from 'react-redux';
import { getFileTypeInit, getReseFileuploadLogsInit, getReseCustomFileNameInit } from './redux/actions';
import { getReseUserTableStoreInit } from '../rese-users/redux/actions';
import ReseFileuploadLogs from './ReseFileuploadLogs';
import './ReseFileupload.scss';
import { RESE_FILE_UPLOAD_TYPES } from '../constants';

function ReseFileupload() {

    const fileInputRef = useRef(null);
    const [selectedFileType, setSelectedFileType] = useState(null);
    const [selectedCustomFileName, setSelectedCustomFileName] = useState(null);
    const [selectedFile, setSelectedFile] = useState();
    const [selectedFileName, setSelectedFileName] = useState();
    const [displayDialog, setDisplayDialog] = useState(false);
    const [displayDriverDialog, setDriverDisplayDialog] = useState(false);
    const [resultMessage, setResultMessage] = useState(null);
    const [showResultMessage, setShowResultMessage] = useState(false);
    const [fileUploadError, setFileUploadError] = useState([]);
    const [snowTicketNumber, setSnowTicketNumber] = useState("");
    const [description, setDescription] = useState("");
    const [store, setStoreNumber] = useState("");
    const [uploadType, setUploadType] = useState(null);
    const [storeNumberError, setStoreNumberError] = useState(""); // State for Store Number error
    const [jsonError, setJsonError] = useState("");
    const fileService = new ReseFileuploadService();
    const [downloadTemplateUrl, setDownloadTemplateUrl] = useState('');
    const [filteredStores, setFilteredStores] = useState(null);
    const reseUserTableStores = useSelector((state => state.reseUser.reseUserTableStoreData))
    console.log("Stores",reseUserTableStores);

    /**
    * Fetch the File types and list it into File Type dropdown field
    */
    const fileTypes = useSelector(state => state.fileUpload.fileTypeList);
    const customFileNames = useSelector(state => state.fileUpload.reseCustomFileNameData);
    const activeCustomFileTypes = customFileNames
        ?.filter((type) => type.isCustomSupported === "Y")
        .map((file) => ({
            ...file,
            custFileName: file.custFileName.replace(/\.json$/i, ""), // Remove .json extension
        })) || [];
    console.log("Active Custom File Types:", activeCustomFileTypes);
    const activeFileTypes = fileTypes?.filter(type => type.status === "Active") || [];
    const [jsonText, setJsonText] = useState(""); // State for JSON text
    const dispatch = useDispatch();

    
    useEffect(() => {
            fetchReseUserTableStores()
        },[]);
        
    useEffect(() => {
        dispatch(getFileTypeInit());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getReseCustomFileNameInit());
    }, [dispatch]);

    useEffect(() => {
        if (!!fileTypes && fileTypes.length > 0) {
            fileTypeChange({ value: activeFileTypes[0] })
        }
        return () => setDownloadTemplateUrl('');
    }, [fileTypes])

    useEffect(() => {
        if (selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name) {
            setUploadType("default"); // Set the default value for uploadType
        }
    }, [selectedFileType]);

    // Reset uploadType when selectedFileType changes
    useEffect(() => {
        if (selectedFileType?.name !== RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name) {
            setUploadType(null); // Reset uploadType
            setSelectedCustomFileName(null); // Clear selected custom file name
            setJsonText(""); // Clear JSON text
        }
    }, [selectedFileType]);

    // Declare the ref outside the useEffect
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (activeCustomFileTypes.length > 0 && !hasInitialized.current) {
            const defaultFileName = activeCustomFileTypes[0];
            const fileName = `${defaultFileName.custFileName}.json`; // Append .json extension
            loadJsonContent(fileName);
            setSelectedCustomFileName(defaultFileName); // Set the default dropdown value
            hasInitialized.current = true; // Mark as initialized
        }
    }, [activeCustomFileTypes]);


    const fetchReseUserTableStores = () => {
            const storeColumnPayload = {
                targetColumn: "store_id",
                tableName: "store"
            }
            dispatch(getReseUserTableStoreInit(storeColumnPayload));
        }
    /**
	 * As User types in Input search will filter the stores
	 */
    const searchStore = (event) => {
        setTimeout(() => {
            let _filteredStores = [];
            if (!event.query.trim().length) {
                _filteredStores = []; // Show no suggestions if the input is empty
            } else if (reseUserTableStores && reseUserTableStores.length > 0) {
                _filteredStores = reseUserTableStores.filter((store) =>
                    store && store.toLowerCase().startsWith(event.query.toLowerCase())
                );
            }
            setFilteredStores(_filteredStores); // Update the filtered stores
        }, 250);
    };
    /**
    * To bind the selected dropdown value to Device Type field
    */
    const fileTypeChange = (e) => {
        setSelectedFileType(e.value);
        // Clear Store Number when File Type changes
        setStoreNumber("");
        setStoreNumberError("");
        if ((e.value.name !== RESE_FILE_UPLOAD_TYPES.ENERGY_METER.name) && (e.value.name !== RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name)) {
            fileService.getTemplateUrl(e.value.name)
                .then(url => setDownloadTemplateUrl(url))
                .catch(() => setDownloadTemplateUrl(''));
        }
    }

    // Handle custom radio button click
    const handleCustomRadioClick = () => {
        // Validate Store Number
        if (!store || store.trim().length === 0) {
            setStoreNumberError("Store number cannot be empty.");
            return; // Prevent switching to the Custom radio button
        }
        if (!reseUserTableStores.includes(store)) {
            setStoreNumberError("Invalid store number. Please select a valid store.");
            return; // Prevent switching to the Custom radio button
        }
        // Clear previous errors
        setStoreNumberError("");
        // Clear JSON error when the dropdown value changes
        setJsonError("");

        // Set the upload type to "custom"
        setUploadType("custom");

        // Set default dropdown value and load JSON content
        const defaultFileName = activeCustomFileTypes[0]; // First item in the dropdown
        setSelectedCustomFileName(defaultFileName);

        // Load JSON content for the default file
        if (defaultFileName && defaultFileName.custFileName) {
            const fileName = `${defaultFileName.custFileName}.json`; // Append .json extension
            loadJsonContent(fileName);
        }
    };

    // Load JSON content for the selected file
    const loadJsonContent = async (fileName) => {
        try {
            // Ensure the API is called only for "Driver Configuration"
            if (selectedFileType?.name !== RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name) {
                setJsonText(""); // Clear JSON content if not "Driver Configuration"
                return;
            }
            // Call the API to fetch the JSON content
            const jsonContent = await getDriverConfigFileContent(
                selectedFileType?.name, // Pass the selected file type name
                store,                  // Pass the store number
                fileName                // Pass the selected file name
            );

            // Set the JSON content in the text area
            setJsonText(JSON.stringify(jsonContent, null, 2)); // Format JSON content
        } catch (error) {
            setJsonText("Error loading JSON content.");
        }
    };

    // Handle dropdown value change for custom file names
    const handleDropdownChange = (e) => {
        setSelectedCustomFileName(e.value);
        // Clear JSON error when the dropdown value changes
        setJsonError("");
        // Load JSON content for the selected file
        if (e.value && e.value.custFileName) {
            const fileName = `${e.value.custFileName}.json`; // Append .json extension
            loadJsonContent(fileName);
        }
    };

    const handleUpload = () => {
        // Validate Store Number
        console.log("Store:", store);
        console.log("Store Number Error:", storeNumberError);
        if (selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name && (!store || store.trim().length === 0)) {
            setStoreNumberError("Store number cannot be empty.");
            return;
        }

        try {
            // Clear previous errors
            setStoreNumberError("");
            setFileUploadError([]); // Clear file upload errors
            setJsonError(""); 
            // Validate JSON content
            let jsonContent;
            try {
                jsonContent = JSON.parse(jsonText);
            } catch (error) {
                setJsonError("JSON structure is invalid. Please fix the JSON and try again.");
                return; // Stop the upload process
            }

            // Create a Blob from the JSON content
            const blob = new Blob([JSON.stringify(jsonContent, null, 2)], { type: "application/json" });

            // Use the selected dropdown value as the file name and ensure it has a .json extension
            let fileName = selectedCustomFileName.custFileName || "default";
            if (!fileName.toLowerCase().endsWith(".json")) {
                fileName += ".json"; // Append .json if not present
            }

            // Create a File object
            const file = new File([blob], fileName, { type: "application/json" });
            // Prepare FormData for the API call
            const formData = new FormData();
            formData.append("file", file);
            // Send the file to the API
            fileService
                .bulkUpload(formData, selectedFileType.name, snowTicketNumber.trim(), description.trim(), store.trim())
                .then((res) => {
                    if (res) {
                        dispatch(getReseFileuploadLogsInit());
                        setResultMessage("Uploaded Successfully");
                        setShowResultMessage(true);
                        setTimeout(() => {
                            setResultMessage("");
                            setShowResultMessage(false);
                            setUploadType("default"); // Reset to "File (Default)"
                            setSelectedCustomFileName(null); // Clear selected custom file name
                            setJsonText(""); // Clear JSON content
                            setStoreNumber(""); // Clear Store Number
                            setSnowTicketNumber(""); // Clear Snow Ticket Number
                            setDescription(""); // Clear Description
                            //window.location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    setFileUploadError(error?.response?.data?.detailList || ["Upload failed."]);
                    setResultMessage("Upload Failed");
                    setShowResultMessage(true);
                    setTimeout(() => {
                        setResultMessage("");
                        setShowResultMessage(false);
                    }, 5000);
                });
        } catch (error) {
            setFileUploadError(["Invalid JSON content. Please fix the JSON and try again."]);
        }
    };
    const handleRefactorJson = async () => {
        try {
            // Reload the JSON content from the selected file
            if (selectedCustomFileName && selectedCustomFileName.custFileName) {
                const fileName = `${selectedCustomFileName.custFileName}.json`; // Append .json extension
                const jsonContent = await getDriverConfigFileContent(
                    selectedFileType?.name, // Pass the selected file type name
                    store,                  // Pass the store number
                    fileName                // Pass the selected file name
                );
    
                // Set the refreshed JSON content in the text area
                setJsonText(JSON.stringify(jsonContent, null, 2)); // Format JSON content
                setJsonError(""); // Clear any previous JSON errors
            } else {
                setJsonError("No file selected to refresh JSON content.");
            }
        } catch (error) {
            // If an error occurs while reloading, display an error message
            setJsonError("Failed to refresh JSON content. Please try again.");
        }
    };
    /**
    * To select the Device Bulk upload Excel file
    * @param {Object} event - Selected file
    */
    const onFileSelect = (event) => {
        const fileName = event.files[0].name;
        const fileSize = event.files[0].size;
        const MAX_FILE_SIZE = 10 * 1024 * 1024;
        if (selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name&& uploadType === "default") {
            // Check if the file name exists in the customFileNames list
            const isValidFileName = customFileNames.some(
                (file) => file.custFileName.toLowerCase() === fileName.toLowerCase()
            );

            if (!isValidFileName) {
                setFileUploadError([
                    `Allowed file names: ${customFileNames.map((file) => file.custFileName).join(", ")}`,
                ]);
                fileInputRef.current.clear(); // Clear the file input
                return false;
            }
        }

        if ((fileName.toLowerCase().endsWith('.csv') || fileName.toLowerCase().endsWith('.xlsx') || fileName.toLowerCase().endsWith('.json') || fileName.toLowerCase().endsWith('.txt')) && fileSize <= MAX_FILE_SIZE) {
            setSelectedFile(event.files[0]);
            setSelectedFileName(event.files[0].name);
            return true;
        }
        fileInputRef.current.clear();
        if (selectedFileType?.name !== RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name) {
            setDisplayDialog(true);
        }
        else {
            setDriverDisplayDialog(true);
        }
        return false;
    }
    /**
    * Upload the selected Device Bulk upload file into database
    */
    const onFileUpload = () => {
        if (selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name && uploadType === "default" && (!store || store.trim().length === 0)) {
            setStoreNumberError("Store number cannot be empty.");
            return;
        }
        if (selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name && uploadType === "default" && !reseUserTableStores.includes(store)) {
            setStoreNumberError("Invalid store number. Please select a valid store.");
            return; // Prevent file upload
        }
        if (selectedFileType.fileType
            && (!snowTicketNumber || snowTicketNumber.trim().length === 0)) {
            setFileUploadError(["Snow Ticket # cannot be empty"]);
        }
        else if (selectedFileType.fileType
            && (!description || description.trim().length === 0)) {
            setFileUploadError(["Description cannot be empty"]);
        } else if (selectedFileType.fileType && description.length > 150) {
            setFileUploadError(["Description cannot have more than 150 characters"]);
        } else {
            setFileUploadError([]);
            setStoreNumberError("");
            const formData = new FormData();
            formData.append('file', selectedFile);
            fileService.bulkUpload(formData, selectedFileType.name, snowTicketNumber.trim(), description.trim(), store).then(res => {
                if (res) {
                    dispatch(getReseFileuploadLogsInit());
                    setResultMessage('Uploaded Successfully');
                    setFileUploadError([]);
                    setShowResultMessage(true);
                    fileInputRef.current.clear();
                    window.location.reload()
                    setTimeout(() => {
                        setResultMessage('');
                        setShowResultMessage(false);
                    }, 5000);
                }
            }).catch(error => {
                setFileUploadError(error?.response?.data?.detailList);
                setResultMessage('Upload Failed');
                setShowResultMessage(true);
                dispatch(getReseFileuploadLogsInit());
                setTimeout(() => {
                    setResultMessage('');
                    setShowResultMessage(false);
                }, 5000);
            });
        }
    }
    return (
        <div className="fileupload-container container-fluid">
            <p className="page-label">
                RESE
                <i className="pi pi-angle-right" />
                File upload
            </p>
            <div className="row" data-testid="upload-container-dropdown">
                <div className="col-12 col-lg-2">
                    <label>File Type</label>
                    {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.ENERGY_METER.name &&
                        (
                            <>
                                <Tooltip target=".status-info" >
                                    <div className="status-info-tooltip">
                                        <span>File Type should be in csv format and example file name <span style={{ fontWeight: "bold" }}>"0006 Meter Data (12-1-2024 to 1-26-2025).csv"</span></span>
                                    </div>
                                </Tooltip>


                                <i className="pi pi-info-circle info-circle status-info" data-pr-position="top" style={{ color: "#00529F", fontSize: "14px", marginLeft: "10px" }}></i>
                            </>)}
                    {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.USER.name &&
                        (
                            <>
                                <Tooltip target=".status-info" >
                                    <div className="status-info-tooltip">
                                        <span>File Type should be xlsx format and please download the template where "email" field is mandatory</span>
                                    </div>
                                </Tooltip>


                                <i className="pi pi-info-circle info-circle status-info" data-pr-position="top" style={{ color: "#00529F", fontSize: "14px", marginLeft: "10px" }}></i>
                            </>)}
                    {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.BMS_BRAND.name &&
                        (
                            <>
                                <Tooltip target=".status-info" >
                                    <div className="status-info-tooltip">
                                        <span>File Type should be xlsx format and please download the template where all fields are mandatory</span>
                                    </div>
                                </Tooltip>


                                <i className="pi pi-info-circle info-circle status-info" data-pr-position="top" style={{ color: "#00529F", fontSize: "14px", marginLeft: "10px" }}></i>
                            </>)}
                    {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.STORE.name &&
                        (
                            <>
                                <Tooltip target=".status-info" >
                                    <div className="status-info-tooltip">
                                        <span>File Type should be xlsx format and please download the template where columns highlighted in red are mandatory</span>
                                    </div>
                                </Tooltip>


                                <i className="pi pi-info-circle info-circle status-info" data-pr-position="top" style={{ color: "#00529F", fontSize: "14px", marginLeft: "10px" }}></i>
                            </>)}
                    {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.BMS.name &&
                        (
                            <>
                                <Tooltip target=".status-info" >
                                    <div className="status-info-tooltip">
                                        <span>File Type should be xlsx format and please download the template where columns highlighted in red are mandatory</span>
                                    </div>
                                </Tooltip>


                                <i className="pi pi-info-circle info-circle status-info" data-pr-position="top" style={{ color: "#00529F", fontSize: "14px", marginLeft: "10px" }}></i>
                            </>)}
                </div>
                <div className="col-12 col-lg-10">

                    <Dropdown value={selectedFileType} options={activeFileTypes} optionLabel="name" onChange={fileTypeChange}
                        className="input" placeholder="Select file type to upload" data-testid="onboarding-dropdown" />
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-lg-2">
                    <label>Snow Ticket #</label>
                </div>
                <div className="col-12 col-lg-10">
                    <InputText value={snowTicketNumber} onChange={e => setSnowTicketNumber(e.target.value)} />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-lg-2">
                    <label>Description</label>
                </div>
                <div className="col-12 col-lg-10">
                    <InputText value={description} onChange={e => setDescription(e.target.value)} />
                </div>
            </div>
            {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name &&
                (
                    <>
                        <div className="row">
                            <div className="storeNum row col-12 col-lg-6">
                                <div className="col-12 col-lg-4">
                                    <label>Store Number</label>
                                </div>
                                <div className="col-12 col-lg-4">
                                <AutoComplete name="storeInput"
                                    value={store} onChange={(e) => {
                                    const value = e.value;
                                    
                                    // Allow only numeric values
                                    if (/^\d*$/.test(value)) {
                                        // Validate the store number against the list of valid stores
                                        if (reseUserTableStores.includes(value)) {
                                            setStoreNumber(value); // Set the valid store number
                                            setStoreNumberError(""); // Clear any previous error
                                        } else {
                                            setStoreNumber(value); // Set the entered value
                                            setStoreNumberError("Invalid store number. Please select a valid store."); // Show error for invalid store
                                        }
                                    } else {
                                        setStoreNumberError("Store number must be numeric."); // Show error for non-numeric input
                                    }
                                }}
                                    suggestions={filteredStores} 
                                    completeMethod={searchStore} />
                                </div>
                                <div className="col-12">
                                    {storeNumberError && (
                                        <div className="error" style={{ color: "red", marginTop: "5px", padding: "0px" }}>
                                            {storeNumberError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="driver-config row col-12 col-lg-6">
                                <div className="col-12 col-lg-3">
                                    <label>Upload Type</label>
                                </div>
                                <div className="driver-config-upload col-12 col-lg-8">
                                    <div>
                                        <RadioButton
                                            inputId="default"
                                            name="defaultOption"
                                            value="default"
                                            onChange={(e) => setUploadType(e.value)}
                                            checked={uploadType === "default"}
                                        />
                                        <label htmlFor="default">
                                            File
                                        </label>
                                    </div>

                                    <div>
                                        <RadioButton
                                            inputId="custom"
                                            name="customOption"
                                            value="custom"
                                            //disabled={isUploadTypeDisabled}
                                            onChange={handleCustomRadioClick}
                                            checked={uploadType === "custom"}
                                        />
                                        <label htmlFor="custom">
                                            Custom
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }

            {uploadType === "custom" && (
                <div className="row" data-testid="file-container-dropdown">
                    <div className="col-12 col-lg-2">
                        <label>Select File</label>
                    </div>
                    <div className="col-12 col-lg-4">

                        <Dropdown value={selectedCustomFileName} options={activeCustomFileTypes} optionLabel="custFileName" onChange={handleDropdownChange}
                            className="input" placeholder="Select files to upload" data-testid="files-dropdown" />
                    </div>
                    {selectedCustomFileName && (
                        <div className="row" style={{ padding: "10px 0px 0px 12px" }}>
                            <div className="col-10">
                                <label>JSON Content</label>
                                <InputTextarea
                                    value={jsonText}
                                    onChange={(e) => setJsonText(e.target.value)}
                                    rows={10}
                                    cols={50}
                                    className="json-textarea"
                                />
                                {jsonError && (
                                    <div className="error" style={{ color: "red", marginTop: "5px", padding: "0px" }}>
                                        {jsonError}
                                    </div>
                                )}  
                            </div>
                            <div className="col-10" style={{ textAlign: "right" }}>
                            <Button
                                label="Reset JSON"
                                icon="pi pi-refresh"
                                onClick={handleRefactorJson}
                                className="p-button"
                                style={{ marginRight: "12px" }}
                            />
                                
                            <Button
                                label="Upload"
                                icon="pi pi-upload"
                                onClick={handleUpload}
                                className="p-button"
                            />
                            </div>
                        </div>
                    )}
                </div>

            )}
            {uploadType !== "custom" && (
                <div className="bulk-upload">
                    {showResultMessage &&
                        <div className="bulk-upload-success">
                            <div>{selectedFileName}</div>
                            <span>{resultMessage}</span>
                        </div>
                    }
                    {
                        fileUploadError && fileUploadError.map((error) => {
                            if (error !== "Store number cannot be empty.") {
                                return (<div className="error" key={error}>{error}</div>
                                );
                            }
                            return null;
                        })
                    }
                    {selectedFileType?.name !== RESE_FILE_UPLOAD_TYPES.ENERGY_METER.name && selectedFileType?.name !== RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name &&
                        (
                            <>
                                <div className="url-container">
                                    {selectedFileType && <a className="download-template" href={downloadTemplateUrl} download>Download Template</a>}
                                </div>
                            </>
                        )}
                    <FileUpload ref={fileInputRef} name="file" className="bulk-upload-button" customUpload={true} onSelect={onFileSelect} uploadHandler={onFileUpload} accept=".csv,.xlsx,.json,.txt" disabled={!selectedFileType}
                        emptyTemplate={<div><span className="or-text">or</span><p className="p-m-0"><img src={fileUpload} alt="" /> Drag and Drop Excel File</p></div>} />
                </div>
            )}
            <Dialog header="Alert" visible={displayDialog} style={{ width: '30vw' }} onHide={() => setDisplayDialog(false)}>
                You can only upload csv file with maximum size of 10MB
            </Dialog>
            {selectedFileType?.name === RESE_FILE_UPLOAD_TYPES.DRIVER_CONFIGURATION.name &&
                (
                    <>
                        <Dialog header="Alert" visible={displayDriverDialog} style={{ width: '30vw' }} onHide={() => setDriverDisplayDialog(false)}>
                            You can only upload json or txt file with maximum size of 10KB
                        </Dialog>
                    </>
                )}


            <hr />
            <ReseFileuploadLogs />
        </div>
    );
}

export default ReseFileupload;